// @flow
// ----------------------------------------------------------------------
// <copyright file='Izenda.Activation.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import { isNil } from 'lodash/fp';
import connect from 'share/enhancers/Izenda.Connect';
import ExpirationPassword from 'modules/Account/Izenda.ExpirationPassword';
import PasswordSetup from 'modules/Account/Izenda.PasswordSetup';
import actions from 'modules/Account/Izenda.ActivationActions';

class Activation extends Component {
  componentWillMount() {
    this.props.initStore(this);
    this.props.authorization.clear();
  }

  componentDidMount() {
    this.props.validateExpirationPasswordLink(this);
  }

  render() {
    const { model: { isExpiration } } = this.store;
    if (isNil(isExpiration)) return null;

    return isExpiration ? <ExpirationPassword /> : <PasswordSetup store={this.store} />;
  }
}

export default connect(actions)(Activation);



// WEBPACK FOOTER //
// ./ui/modules/Account/Izenda.Activation.js